import { ReactNode } from 'react'
import Text from '@/stories/components/Common/NewText'

const OuterWidget = ({
  children,
  title = '',
  sub_title = '',
  footer_text = '',
}: {
  children: ReactNode
  title?: string
  sub_title?: string
  footer_text?: string
}) => {
  return (
    <div>
      {title && (
        <div className="border-b-1 mb-6 border-gray-200 pb-6">
          <Text tag="h2" appearance="heading2">
            {title}
          </Text>
        </div>
      )}
      {sub_title && <Text appearance="body2">{sub_title}</Text>}
      {children}
      {footer_text && (
        <div className="mt-4">
          <Text appearance="body2">{footer_text}</Text>
        </div>
      )}
    </div>
  )
}

export default OuterWidget
